import PropTypes from 'prop-types';
import { Component, Children, cloneElement } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import {
    loadBinder,
    removeBinder,
    removeUsers,
} from 'binder/actions';

import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';

export class BinderView extends Component {
    loadBinder(){
        const { binderId, loadBinder } = this.props;
        loadBinder(binderId);
    }

    loadSlimBinder() {
        const { binderId, loadBinder } = this.props;
        const useSlimLayout = true;
        loadBinder(binderId, useSlimLayout);
    }

    loadFullBinderIfNeeded(currentLocation, nextLocation, binder) {
        const isBinderWithSlimLayout = lodash.get(binder, 'isBinderWithSlimLayout', false);
        if(isBinderWithSlimLayout) {
            const subPath = this.getSubPath(currentLocation);
            const nextSubPath = this.getSubPath(nextLocation);
            const leavingFilesPage = (subPath === 'files' && nextSubPath !== 'files');
            if(leavingFilesPage) {
                this.loadBinder();
            }
        }
    }

    getSubPath(location) {
        return lodash.last(location.pathname.split('/'));
    }

    componentDidMount(){
        const { location } = this.props;
        const subPath = this.getSubPath(location);
        if(subPath === 'files') {
            return this.loadSlimBinder();
        }
        return this.loadBinder();
    }

    componentDidUpdate(prevProps) {
        const { binder, location } = this.props;
        if (!binder || !binder.id || !location) return;
        const { router } = this.context;
        const allowedPathsWithNewStatus = [
            `binder/${binder.id}/setup/?`,
            `binder/${binder.id}/?`,
            `binder/${binder.id}/edit/?`
        ];
        this.loadFullBinderIfNeeded(prevProps.location, location, binder);
        const setupPathRe = new RegExp(`(${allowedPathsWithNewStatus.join('|')})$`, 'i');
        if(!setupPathRe.test(location.pathname)){
            if(`${binder.status}`.toLowerCase() === 'new'){
                router.replace(`/binder/${binder.id}/setup`);
                this.setState({
                    links: []
                });
            }
        }
    }

    componentWillUnmount(){
        this.props.removeBinder();
        this.props.removeUsers();
    }

    /**
     * Checks if core binder fields have loaded
     * before rendering child components.
     */
    binderIsFullyAvailable(binder) {
        return !lodash.isEmpty(binder)  &&
            !lodash.isNil(binder.title) && 
            !lodash.isNil(binder.layout);
    }

    render() {
        const { binder, binderId } = this.props;
        const childElement = cloneElement(Children.only(this.props.children), {
            binderId: binderId,
            binder: binder,
            loadBinder: this.loadBinder.bind(this)
        });
        
        if (this.binderIsFullyAvailable(binder)) {
            return childElement;
        } 
            
        return <LoadingStatus loading={true} filterQuery={false} />;
    }
}

BinderView.propTypes = {
    children: PropTypes.element.isRequired
};

BinderView.contextTypes = {
    router: PropTypes.object.isRequired
};

export default connect((state,props) => {
    const binder = lodash.get(state, 'binder', {});
    const users = lodash.get(state, 'users', []);
    return{
        binder,
        users,
        binderId: props.params.id
    };
}, {
    loadBinder,
    removeBinder,
    removeUsers,
})(BinderView);
